import { render, staticRenderFns } from "./bpm.vue?vue&type=template&id=23548764&scoped=true"
import script from "./bpm.vue?vue&type=script&lang=js"
export * from "./bpm.vue?vue&type=script&lang=js"
import style0 from "./bpm.vue?vue&type=style&index=0&id=23548764&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23548764",
  null
  
)

export default component.exports